module.exports = __webpack_public_path__ + "52f506c2acf7bd08139d6169bac19743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/logo.png
// module id = 168
// module chunks = 0